import cn from 'classnames';

import { ReactComponent as ExternalLinkIcon } from 'assets/external-link.svg';
import PodcastDestinationLink from 'components/PodcastDestinationLink';
import styles from './ContinueListeningLink.module.scss';

export interface ContinueListeningLinkProps {
  className?: string;
}

const ContinueListeningLink: React.FC<ContinueListeningLinkProps> = ({
  className,
}) => (
  <PodcastDestinationLink className={cn(styles.link, className)}>
    <ExternalLinkIcon height="20" width="20" />
    <span className={styles.text}>continue listening</span>
  </PodcastDestinationLink>
);

export default ContinueListeningLink;
